/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Image,
  ImageSourcePropType,
  Platform,
  ScrollView,
  Text,
  View,
} from 'react-native';
import {connect} from 'react-redux';
import SubmitButtons from '../../../../components/Button/SecondaryButton';
import Label from '../../../../components/Label';

import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import {formatDateTo} from '../../../../../common/utils/functions';
import config from '../../../../../data/config';
import {dataConfig} from '../../../../../data/constants/Assurance/AssuranceVoyage/souscription';
import {IValues} from '../../../../../data/types/interface/Assurance/AssuranceVoyage/souscription';
import mapDispatchToProps from '../../../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../../../services/redux/mapStateToProps';
import {
  BoxShadowed,
  LinkWithIconDownload,
} from '../../../../components/AssuranceVoyage';
import {SelectType} from '../../../../components/AssuranceVoyage/SelectType';

const mainTitle = 'RECAPITULATIF';

interface TypeDTO {
  destination: string;
  montant: string;
  quoteCode: string;
}
interface ValidationFormProps {
  onCancel: () => void;
  onSubmit: (data: any) => void;
  data: IValues & {destination: string; quoteCode: string; adresse: string};
  user: any;
  category: string;
  listType: Array<TypeDTO>;
  listCategory: Array<any>;
}
const ConfirmationVoyageFC = ({
  onCancel,
  onSubmit,
  data,
  user,
  listType,
}: ValidationFormProps) => {
  const [recapData] = React.useState({
    ...data,
    offre: 'Standard Travel',
    civilite: 'Malgache',
  });

  console.log(recapData);

  const [typeSelected, setTypeSelected] = React.useState<string>('');

  const isNewDevis = () => !!listType.length;

  const handleSubmit = (values: any) => {
    const currentType: TypeDTO | undefined = isNewDevis()
      ? listType.find((element: any) => element.destination === typeSelected)
      : undefined;
    const res: any = isNewDevis()
      ? {
          ...values,
          montant: currentType?.montant.toString(),
          quoteCode: currentType?.quoteCode.toString(),
        }
      : {...values};

    onSubmit({
      ...res,
    });
  };
  const currentUser = user?.data?.utilisateur;

  return (
    <View style={{flex: 1}}>
      <View style={{marginBottom: 20, paddingHorizontal: 20}}>
        <Label title={mainTitle} type="mainTitle" />
      </View>

      <ScrollView style={{paddingHorizontal: 10}}>
        <BoxShadowed>
          <Label title="Résumé de votre voyage" />
          <View>
            <Label title={'Offre :'} type="titleGreen14" />
            <Label title={`${recapData.offre}`} />
          </View>

          <View>
            <Label title={'Destination :'} type="titleGreen14" />
            <Label title={recapData.destination} />
          </View>
          <Text>
            <Label title={'Vous voyagerez du '} type="titleGreen14" />
            <Label
              title={`${formatDateTo(
                recapData.dateDebut,
                'DD/MM/YYYY',
              ).toString()}`}
            />
            <Label title={' au '} type="titleGreen14" />
            <Label
              title={`${formatDateTo(
                recapData.dateFin,
                'DD/MM/YYYY',
              ).toString()}`}
            />
          </Text>
        </BoxShadowed>

        {recapData.assure.length
          ? recapData.assure.map(currentAssured => {
              console.log('>', currentAssured.passport_file[0]);

              return (
                <BoxShadowed
                  key={`list_assured_recap_${currentAssured.id}`}
                  style={
                    Platform.OS === 'web'
                      ? {
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          flexWrap: 'wrap',
                        }
                      : {}
                  }>
                  <View style={{maxWidth: '100%'}}>
                    <Label title="Bénéficiaire" />
                    <View>
                      <Label title={'Le voyageur est :'} type="titleGreen14" />
                      <Label
                        title={
                          dayjs().diff(
                            dayjs(
                              currentAssured.dateNaissance,
                              'DD/MM/YYYY',
                            ).isValid()
                              ? dayjs(
                                  currentAssured.dateNaissance,
                                  'DD/MM/YYYY',
                                )
                              : dayjs(currentAssured.dateNaissance),
                            'year',
                          ) >= dataConfig.ageGap.adult.min
                            ? `Adulte`
                            : 'Mineur'
                        }
                      />
                    </View>
                    <View>
                      <Label title={'Nom :'} type="titleGreen14" />
                      <Label title={currentAssured.nom} />
                    </View>
                    <View>
                      <Label title={'Prénom :'} type="titleGreen14" />
                      <Label title={currentAssured.prenom} />
                    </View>
                    <View>
                      <Label
                        title={'Date de naissance :'}
                        type="titleGreen14"
                      />
                      <Label
                        title={dayjs(currentAssured.dateNaissance).format(
                          'DD/MM/YYYY',
                        )}
                      />
                    </View>
                    <View>
                      <Label
                        title={'Numéro de passeport :'}
                        type="titleGreen14"
                      />
                      <Label title={currentAssured.numPasseport} />
                    </View>
                    <View>
                      <Label title={'Civilité :'} type="titleGreen14" />
                      <Label title={recapData.civilite} />
                    </View>
                  </View>
                  <View style={{maxWidth: '100%'}}>
                    <Image
                      source={
                        (Platform.OS == 'web'
                          ? URL.createObjectURL(currentAssured.passport_file[0])
                          : {
                              uri: currentAssured.passport_file[0].uri,
                            }) as ImageSourcePropType
                      }
                      style={
                        Platform.OS === 'web'
                          ? {
                              width: 400,
                              maxWidth: '100%',
                              height: 250,
                              resizeMode: 'contain',
                            }
                          : {width: '100%', height: 250, resizeMode: 'contain'}
                      }
                    />
                  </View>
                </BoxShadowed>
              );
            })
          : null}

        <BoxShadowed>
          <Label title="Souscripteur" />
          <View>
            <Label title={'Nom :'} type="titleGreen14" />
            <Label title={currentUser.nom} />
          </View>
          <View>
            <Label title={'Prénom :'} type="titleGreen14" />
            <Label title={currentUser.prenom} />
          </View>
          <View>
            <Label title={'Email'} type="titleGreen14" />
            <Label title={currentUser.email} />
          </View>
        </BoxShadowed>

        <View style={{padding: 10}}>
          <Label title={"Vous avez choisi l'offre"} />
          <SelectType
            onSelect={(name: string, value: string) => setTypeSelected(value)}
            selected={String(typeSelected)}
            listTypes={
              isNewDevis()
                ? listType
                : [
                    {
                      montant: recapData.montant,
                      destination: recapData.destination,
                    },
                  ]
            }
          />

          <LinkWithIconDownload
            text="Conditions Générales.pdf"
            url={config.voyageCG}
          />

          <LinkWithIconDownload
            text="Notice d'information.pdf"
            url={config.voyageNotice}
          />
        </View>

        <View style={{height: 150}} />
      </ScrollView>

      <View
        style={{
          position: 'absolute',
          paddingHorizontal: 20,
          bottom: 0,
          width: '100%',
          backgroundColor: 'white',
        }}>
        <SubmitButtons
          style={{marginTop: 0, paddingTop: 10}}
          cancelAction={() => onCancel()}
          submitAction={() => handleSubmit(recapData)}
          cancelTitle="Annuler"
          submitTitle={'Valider'}
          isDisable={isNewDevis() && !typeSelected}
        />
      </View>
    </View>
  );
};

export const ConfirmationVoyage: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ConfirmationVoyageFC);
